const templateColumns = [
	{ field: 'templateName', header: 'Template Name' },
	{ field: 'templateDescription', header: 'Template Description' },
	{ field: 'createdBy', header: 'Created By' },
];

export default templateColumns;
